import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Checkbox } from 'semantic-ui-react';

import './ImageSliderAutoAdvanceCheckbox.css';

class ImageSliderAutoAdvanceCheckbox extends Component {
  static propTypes = {
    patchImageSlider: PropTypes.func.isRequired,
    isAutoAdvance: PropTypes.bool,
    sliderItem: PropTypes.object.isRequired,
  };

  static defaultProps = {
    isAutoAdvance: null,
  };

  state = {
    firstChange:  null,
    currentIsAutoAdvance: null,
  };

  componentDidMount() {
    this.setState({ currentIsAutoAdvance: this.props.isAutoAdvance });
  }

  componentDidUpdate(prevProps, prevState) {
    const { sliderItem, patchImageSlider } = this.props;
    const { currentIsAutoAdvance, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentIsAutoAdvance !== this.state.currentIsAutoAdvance
    ) {
      patchImageSlider(sliderItem.id, { is_auto_advance: currentIsAutoAdvance });
    }
  }

  onCheckboxChange = () => {
    this.setState({
      firstChange: true,
      currentIsAutoAdvance: !this.state.currentIsAutoAdvance,
    });
  };

  render() {
    const { isAutoAdvance } = this.props;
    const { firstChange, currentIsAutoAdvance } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="image-slider-auto-advance-checkbox__component">
            <Checkbox
              checked={firstChange ? currentIsAutoAdvance : isAutoAdvance}
              onChange={this.onCheckboxChange}
            />
            <div className="label">{t("Advance images automatically")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

export default connect(
  null,
  {
    patchImageSlider,
  },
)(ImageSliderAutoAdvanceCheckbox);
